import { render, staticRenderFns } from "./AboutDateCellEditor.vue?vue&type=template&id=6a551f80&"
import script from "./AboutDateCellEditor.vue?vue&type=script&lang=js&"
export * from "./AboutDateCellEditor.vue?vue&type=script&lang=js&"
import style0 from "./AboutDateCellEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VBtn,VBtnToggle,VDatePicker})
